import React, { FC, useState, useEffect } from 'react';
import classNames from 'classnames';

import styles from './filters_toggle.module.scss';

type Props = {
  filters: {
    label: string;
    value: string;
    selected?: boolean;
    combinedWithNext?: boolean;
  }[];
  onFilterClick: (value: string) => void;
  filterParam?: string | null;
  disableFilterClick?: boolean;
};

export const FiltersToggle: FC<Props> = ({
  filters,
  onFilterClick,
  filterParam = null,
  disableFilterClick = false,
}) => {
  const [filterSelected, setFilterSelected] = useState<string | null>(
    filters.filter((f) => f.selected).map((f) => f.value)[0],
  );

  const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if (e.currentTarget.value !== filterSelected) {
      if (!disableFilterClick) setFilterSelected(e.currentTarget.value);
      onFilterClick(e.currentTarget.value);
    }
  };

  useEffect(() => {
    if (disableFilterClick) return;
    if (filterParam && filters.filter((f) => f.value === filterParam).length) {
      setFilterSelected(filterParam);
      onFilterClick(filterParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ul className={styles.filtersContainer}>
      {filters.map(({ label, value, selected, combinedWithNext }) => (
        <ol
          key={label}
          className={classNames(styles.filterContainer, {
            [styles.combinedFilter]: combinedWithNext,
          })}
        >
          <button
            type="button"
            className={classNames(styles.filter, {
              [styles.selected]: filterSelected
                ? filterSelected === value
                : selected,
              [styles.combinedBtn]: combinedWithNext,
            })}
            onClick={(e) => onClick(e)}
            value={value}
          >
            {label}
          </button>
        </ol>
      ))}
    </ul>
  );
};
